import {
  FETCH_TAX_ALLOCATIONS_SUCCESS,
  CREATE_TAX_ALLOCATION_SUCCESS,
  DELETE_TAX_ALLOCATION_SUCCESS,
  UPDATE_TAX_ALLOCATION_SUCCESS,
} from '../actions/action-types';

const initialState = {
  taxAllocations: [],
};

const addTaxAllocationSuccess = (state, action) => ({
  ...state,
  taxAllocations: [...state.taxAllocations, action.payload],
});

const deleteTaxAllocationSuccess = (state, action) => ({
  ...state,
  taxAllocations: state.taxAllocations.filter(({ id }) => id !== action.payload),
});

const fetchTaxAllocationsSuccess = (state, action) => ({
  ...state,
  taxAllocations: action.payload,
});

const updateTaxAllocationSuccess = (state, action) => ({
  ...state,
  taxAllocations: state.taxAllocations.map(taxAllocation => (
    taxAllocation.id !== action.payload.id
      ? taxAllocation : action.payload
  )),
});

const taxAllocations = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_TAX_ALLOCATION_SUCCESS:
      return addTaxAllocationSuccess(state, action);
    case DELETE_TAX_ALLOCATION_SUCCESS:
      return deleteTaxAllocationSuccess(state, action);
    case FETCH_TAX_ALLOCATIONS_SUCCESS:
      return fetchTaxAllocationsSuccess(state, action);
    case UPDATE_TAX_ALLOCATION_SUCCESS:
      return updateTaxAllocationSuccess(state, action);
    default:
      return state;
  }
};

export default taxAllocations;